import moment from "moment";
import React, { useEffect, useState } from "react";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { SearchOrganizationOffices } from "../../../../api";

const OfficeList = ({
    office_list,
    showAddOfficeModal,
    deleteOffice,
    editOffice,
    organizationId,
    updateOfficeCount,
    showAddOffice,
}) => {
    const [offices, setOfficesList] = useState(office_list);
    const [searchValue, setSearchedValue] = useState("");
    useEffect(() => {
        setOfficesList(office_list);
        updateOfficeCount(office_list.length);
    }, [office_list, showAddOffice]);

    const searchOffices = (searchValue) => {
        try {
            if (office_list.length) {
                if (searchValue !== "") {
                    SearchOrganizationOffices(organizationId, searchValue)
                        .then((response) => {
                            if (response.success) {
                                const offices = response.offices;
                                setOfficesList(offices);
                                updateOfficeCount(offices.length);
                            }
                        })
                        .catch((error) => console.log(error));
                } else {
                    setOfficesList(office_list);
                    updateOfficeCount(office_list.length);
                }
            }
        } catch (err) {}
    };

    const handleKeyWordChange = (evt) => {
        setSearchedValue(evt.target.value);
        if (evt.target.value.length > 2) {
            searchOffices(evt.target.value);
        } else if (evt.target.value.length == 0) {
            setOfficesList(office_list);
            updateOfficeCount(office_list.length);
        }
    };

    const handleSearchClick = (evt) => {
        evt.preventDefault();
        if (searchValue !== "") searchOffices(searchValue);
    };

    const handleKeyPress = (evt) => {
        if (evt.key === "Enter") {
            evt.preventDefault();
        }
    };

    const handleOfficeDelete = (evt) => {
        confirmAlert({
            title: "Delete Office",
            message: "Are you sure you want to delete the office?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => deleteOffice(evt),
                },
                {
                    label: "No",
                },
            ],
        });
    };
    return (
        <>
            <div className="panel-heading" id="pannel-headingId">
                <div className="header-search">
                    <form>
                        <input
                            value={searchValue}
                            type="text"
                            placeholder="Search Office"
                            name="search"
                            className="search-box"
                            onChange={(evt) => handleKeyWordChange(evt)}
                            onKeyPress={(evt) => handleKeyPress(evt)}
                        />
                        <button onClick={(e) => handleSearchClick(e)}>
                            <i className="fa fa-search"></i>
                        </button>
                    </form>
                </div>
                <div className="d-flex">
                    <button
                        onClick={() => {
                            setSearchedValue("");
                            showAddOfficeModal();
                            setOfficesList(office_list);
                        }}
                        className="orgbtn"
                    >
                        <i className="fa fa-create"></i> Add Office
                    </button>
                </div>
            </div>
            <div className="table-organizations">
                <table
                    className="table table-striped table-responsive"
                    id="organization-index-table"
                >
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {offices && offices.length > 0 ? (
                            offices.map((office, index) => (
                                <tr key={"tr" + index}>
                                    <td>{office.id_within_organization}</td>
                                    <td className="contactTd">
                                        <div className="org-full-name">
                                            <h4>{office.name}</h4>
                                        </div>
                                    </td>
                                    <td className="addresidual">
                                        <span
                                            onClick={(evt) => {
                                                setSearchedValue("");
                                                editOffice(office);
                                            }}
                                        >
                                            Edit
                                        </span>
                                        <span
                                            onClick={(evt) =>
                                                handleOfficeDelete(office.id)
                                            }
                                            className="addresidualIMG"
                                        >
                                            <img src="/images/delet.svg " />
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <p className="no-data text-center">
                                {" "}
                                No data found
                            </p>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default OfficeList;
